import React from "react";
import FilterSize from "./Size";

function FilterHeight({ value, onChange }) {
  return (
    <FilterSize
      title="Height"
      value={value}
      min={0}
      max={30}
      unit="m"
      onChange={onChange}
    />
  );
}

export default FilterHeight;
